export const DS_EMOJI_PICKER_CLASSES = {
  Panel: "ds-emoji-picker__panel",
  Categories: "ds-emoji-picker__categories",
  Category: "ds-emoji-picker__category",
  Search: "ds-emoji-picker__search",
  Grid: "ds-emoji-picker__grid",
  Section: "ds-emoji-picker__section",
  SectionHeading: "ds-emoji-picker__section-heading",
  SectionGrid: "ds-emoji-picker__section-grid",
  Empty: "ds-emoji-picker__empty",
  Footer: "ds-emoji-picker__footer",
  Preview: "ds-emoji-picker__preview",
  PreviewAlias: "ds-emoji-picker__preview-alias",
  Tones: "ds-emoji-picker__tones",
  ToneControl: "ds-emoji-picker__tone-control",
  FastSelect: "ds-emoji-picker__fast-select",
} as const;
